<template>
  <div>
    <div v-if="!exportNeeds"> </div>
    <hr v-if="!exportNeeds" />
    <div>
      <highcharts ref="dvdchart" :options="chartOptionHC"></highcharts>
      <p v-if="!exportNeeds" style="padding-top: 20px; margin-bottom: 0px">
        <b-icon-info></b-icon-info>For focus analysis, please click legend to
        active or in-active series.
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { formMethods } from '@state/helpers'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

exportingInit(Highcharts)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(HighchartsVue)

export default {
  props: {
    wellId: {type: Number, default: undefined},
    exportNeeds: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nptChecked: 1,
      dataMax: 0,
      datacollection: null,
      chartOptionHC: {
        credits: {
          enabled: false,
        },
        chart: {
          height: 450,
          width: this.exportNeeds ? 700 : null,
        },
        exporting: {
          enabled: !this.exportNeeds,
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        mapNavigation: {
          enableMouseWheelZoom: true,
        },
        plotOptions: {
          series: {
            connectNulls: null,
          },
        },
        tooltip: {
          formatter: function () {
            return this.series.name + ' for hole size ' + this.x + ' is <b>' + this.y.toFixed(0)
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + '</b>';
          }
        },
        xAxis: {
          categories: ['8 1/2', '12 1/4', '17 1/2', '26'],
        },
        yAxis: [
          {
            // Primary yAxis
            labels: {
              // format: '{value}°C',
              style: {
                color: Highcharts.getOptions().colors[1],
              },
            },
            title: {
              text: 'Avg Cumm Footage (' + this.$t('unit.ft') + ')',
              style: {
                color: Highcharts.getOptions().colors[1],
              },
            },
          },
          {
            // Secondary yAxis
            title: {
              text: 'Avg of Avg ROP (' + this.$t('unit.ft') + '/hr)',
              style: {
                color: Highcharts.getOptions().colors[5],
              },
            },
            labels: {
              // format: '{value} mm',
              style: {
                color: Highcharts.getOptions().colors[5],
              },
            },
            opposite: true,
          },
        ],
        series: [
          {
            type: 'column',
            name: 'Avg Cumm Footage (' + this.$t('unit.ft') + ')',
            data: [3, 2, 1, 3],
            color: 'green',
            yAxis: 0,
          },
          {
            type: 'column',
            name: 'Avg Cumm Hours (hr)',
            data: [2, 3, 5, 7],
            yAxis: 0,
          },
          {
            type: 'line',
            name: 'Avg of Avg ROP (' + this.$t('unit.ft') + '/hr)',
            data: [3, 2.67, 3, 6.33],
            marker: {
              lineWidth: 2,
              lineColor: Highcharts.getOptions().colors[5],
              fillColor: 'red',
            },
            color: 'red',
            yAxis: 1,
          },
          // {
          //   type: 'pie',
          //   name: 'Total consumption',
          //   data: [
          //     {
          //       name: 'Jane',
          //       y: 13,
          //       color: Highcharts.getOptions().colors[0], // Jane's color
          //     },
          //     {
          //       name: 'John',
          //       y: 23,
          //       color: Highcharts.getOptions().colors[1], // John's color
          //     },
          //     {
          //       name: 'Joe',
          //       y: 19,
          //       color: Highcharts.getOptions().colors[2], // Joe's color
          //     },
          //   ],
          //   center: [100, 80],
          //   size: 100,
          //   showInLegend: false,
          //   dataLabels: {
          //     enabled: false,
          //   },
          // },
        ],
      },
    }
  },

  watch: {
    wellId: function (val) {
      this.loadChart()
    },
  },
  created: function () {
    this.loadChart()
  },
  methods: {
    ...formMethods,
    loadChart() {
      this.getDashboardBitPerformance({ params: { wellId: this.wellId } }).then(
        (resp) => {
          this.chartOptionHC.xAxis.categories = resp.data.data[0]
          this.chartOptionHC.series[0].data = resp.data.data[1]
          this.chartOptionHC.series[1].data = resp.data.data[2]
          this.chartOptionHC.series[2].data = resp.data.data[3]
        }
      )
    },
    nptChanged(val) {
      this.$nextTick().then(() => {
        this.loadChart()
      })
    },
  },
}
</script>